import styled from 'styled-components';

import { Input } from 'src/UIComponents';

export const Container = styled.div`
  position: relative;
`;

export const StyledInput = styled(Input)`
  box-sizing: border-box;
  position: relative;
`;

export const ActionContainer = styled.div`
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
`;

const InputButton = styled.button`
  display: inline-flex;
  align-items: center;
  height: 100%;
  border: 0;
  padding: 0 ${({ theme }) => theme.spacing.sm};
  background: transparent;
`;

type SearchButtonProps = {
  active?: boolean;
};

export const SearchButton = styled(InputButton)`
  opacity: ${({ active }: SearchButtonProps) => (active ? 1 : 0.5)};
  color: ${({ theme }) => theme.colors.primary};
`;

export const CloseButton = styled(InputButton)`
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.7em;
`;
